module.exports = __webpack_public_path__ + "static/media/loyalty-asset.214c3bfd.svg";